import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import { debounce } from "lodash";
import moment from "moment";
import React, { useEffect, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";

import {
  Accordions,
  DialogNoti,
  DialogShowImg,
  Row,
  RuleModal,
  SteperHeader,
} from "../components";
import { styledReviewInfo } from "../components/styeleds/styledReviewInfo";
import { Checkbox } from "../overrideMui";
import { converDate, listBeneficiaryInfo } from "../utils";
import FormReportedAccident from "./formReportAccident";

import img from "../../../../../assets/health/img-icon.svg";


export default function ReviewInfo(props) {
  const { state, dispatch, isApp } = props;
  const classes = styledReviewInfo();
  const resSignature = useRef(null);
  const width = window.innerWidth > 600 ? 600 : window.innerWidth;

  const {
    curenStep,
    listInsuranceesCheck,
    beneficiary,
    insuredInfo,
    loadingSignature,
    checkConditions,
    arrayLinks,
    errors,
    dataSignature,
    accodiorInsuredInfor,
    accodiorBeneficiary,
    insuredGender,
    dialogNoti,
    riskType,
    typeOfIndimnity,
    insuranceType,
    modalRule,
  } = state;

  const insuredInforUser = listInsuranceesCheck[0] || {};
  const gender = [0, 1].includes(insuredInforUser?.insuredInfo?.insuredGender)
    ? insuredInforUser?.insuredInfo?.insuredGender
    : insuredGender;

  const listInsurancedPersonInfo = [
    {
      title: "Họ và tên",
      value:
        insuredInfo?.insuredName ||
        insuredInforUser?.insuredInfo?.insuredName ||
        "",
      capitalize: true,
    },
    {
      title: "Năm sinh",
      value:
        moment(converDate(insuredInfo?.insuredDob || insuredInforUser?.insuredInfo?.insuredDob)).format("DD/MM/YYYY"),
    },
    {
      title: "Giới tính",
      value: gender === 1 ? "Nam" : gender === 0 ? "Nữ" : "",
    },
    {
      title: "CMND/CCCD/ Hộ chiếu",
      value:
        insuredInfo?.insuredPrivateId ||
        insuredInforUser?.insuredInfo?.insuredPrivateId ||
        "",
    },
    {
      title: "Email",
      value:
        insuredInfo?.insuredEmail ||
        insuredInforUser?.insuredInfo?.insuredEmail ||
        "",
    },
    {
      title: "Loại bảo hiểm",
      value: insuranceType?.title,
    },
    {
      title: "Loại bồi thường",
      value: typeOfIndimnity?.title,
    },
    {
      title: "Loại rủi ro",
      value: riskType?.title || "",
      doneShow: insuranceType?.insuranceCode == "suc_khoe",
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div
      className={classes.container}
      style={{
        minHeight: isApp ? "calc(100vh - 175px)" : "calc(100vh - 133px)",
      }}
    >
      <SteperHeader activeStep={curenStep} insuranceType={insuranceType} />
      <Accordions
        classes={classes}
        titleHeader="Thông tin người được bảo hiểm"
        expanded={accodiorInsuredInfor}
        onClick={() =>
          dispatch({ type: "onChangeAccodior", name: "accodiorInsuredInfor" })
        }
      >
        <div style={{ padding: "0 12px" }}>
          {listInsurancedPersonInfo.map((item, index) =>
            item?.doneShow ? null : (
              <Row
                key={index}
                title={item.title}
                capitalize={item.capitalize}
                value={item?.value}
              />
            )
          )}
        </div>
        <div
          className={classes.licenseImg}
          onClick={() => dispatch({ type: "openPageShowImg", name: "img" })}
        >
          <span>Hình ảnh chứng từ</span>
          <KeyboardArrowRightIcon />
        </div>
        <div
          className={classes.licenseImg}
          onClick={() => {
            arrayLinks.filter((i) => !!i).length === 0
              ? dispatch({
                  type: "openSnacbars",
                  typeSnackbar: "warning",
                  message:
                    "Bạn chưa có Link hoá đơn điện tử nào, vui lòng thêm nếu có",
                })
              : arrayLinks.filter((i) => !!i).length === 1
              ? dispatch({ type: "openPageShowLink", index: 0 })
              : dispatch({ type: "openPageShowImg", name: "link" });
          }}
        >
          <span>Hóa đơn điện tử</span>
          <KeyboardArrowRightIcon />
        </div>
      </Accordions>
      <Accordions
        classes={classes}
        titleHeader="Người thụ hưởng"
        expanded={accodiorBeneficiary}
        onClick={() =>
          dispatch({ type: "onChangeAccodior", name: "accodiorBeneficiary" })
        }
      >
        <div style={{ padding: "0 12px" }}>
          {listBeneficiaryInfo.map((item, index) =>
            item.name === "relationshipWithBuyerName" &&
            beneficiary === "self" ? null : (
              <Row
                key={index}
                title={item.title}
                value={
                  beneficiary === "self" && item.name === "beneficiaryName"
                    ? insuredInforUser?.insuredInfo?.insuredName || ""
                    : insuredInfo[item.name]
                }
              />
            )
          )}
        </div>
        {beneficiary === "relative" && (
          <div
            className={classes.proveRelationship}
            onClick={() =>
              dispatch({ type: "openDaShowImg", name: "relationship" })
            }
          >
            <div style={{ maxWidth: "75%" }}>
              {
                " Các giấy tờ chứng minh quan hệ giữa người được bảo hiểm (CMND/CCCD, Giấy kết hôn, Giấy khai sinh, Văn bản ủy quyền...)"
              }
            </div>
            <img src={img} />
          </div>
        )}
      </Accordions>
      <div className={classes.rules}>
        <Checkbox
          disabled={loadingSignature}
          style={{ marginRight: "8px", paddingTop: "3px" }}
          checked={checkConditions}
          onChange={(e) => {
            const element = document.querySelector("#sigCanvas");
            if (e.target.checked && element) {
              window?.scrollTo({
                top: element.offsetTop + 100,
                behavior: "smooth",
              });
            }
            dispatch({ type: "checkConditions", value: e.target.checked });
          }}
        />
        <div style={{ color: errors.checkConditions ? "red" : "" }}>
          Tôi đã đọc kỹ và chấp nhận tất cả{" "}
          <span
            style={{ cursor: "pointer", color: "#0B3C8A" }}
            onClick={() => dispatch("openModalRule")}
          >
            {" "}
            các điều khoản trong Quy tắc Bảo hiểm{" "}
          </span>
          của Công ty bảo hiểm. Tôi cam đoan tất cả các thông tin khai báo ở
          trên là đúng sự thật và hiểu rằng bất kỳ thông tin nào khai báo không
          đúng sự thật có thể sẽ dẫn đến việc Giấy chứng nhận bảo hiểm/ Hợp đồng
          bảo hiểm mất hiệu lực và/hoặc Bảo hiểm Công ty bảo hiểm có quyền từ
          chối một phần hoặc toàn bộ trách nhiệm bồi thường. Tôi đồng ý sẽ thông
          báo cho Công ty bảo hiểm về bất kỳ sự thay đổi thông tin nào{" "}
          {" (nếu có)"}. Tôi đồng ý để cho bác sỹ, bệnh viện hoặc cơ sở y tế đã
          điều trị hoặc tư vấn sức khoẻ cho tôi được cung cấp cho Công ty bảo
          hiểm mọi thông tin liên quan đến sức khoẻ của tôi nếu có sự nghi vấn,
          nhằm đáp ứng các yêu cầu về giải quyết quyền lợi bảo hiểm.
        </div>
      </div>
      <div>
        <div className={classes.signatureTitle}>
          <span>
            Chữ ký của bạn <span style={{ color: "red" }}>*</span>
          </span>
          <span
            style={{ color: "#0B7CE4", textDecoration: "underline" }}
            onClick={() =>
              dispatch({ type: "clearSignature", ref: resSignature })
            }
          >
            Ký lại
          </span>
        </div>
        {errors?.signature && (
          <Box sx={{ marginTop: "12px", color: "red" }}>
            <Typography>Vui lòng ký vào ô bên dưới</Typography>
          </Box>
        )}
        <div className={classes.signature}>
          {dataSignature?.extraInfo?.documents?.length > 0 ? (
            <div
              style={{
                height: "180px",
                padding: "8px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                alt="signature"
                // id="sigCanvas"
                src={dataSignature?.extraInfo?.documents[0]?.path || ""}
                style={{ objectFit: "contain", maxWidth: "90%" }}
              />
            </div>
          ) : (
            <div className={classes.sigCanvas} id="sigCanvas">
              <Backdrop
                style={{
                  zIndex: 99,
                  color: "#fff",
                  position: "absolute",
                  borderRadius: "5px",
                }}
                open={!!loadingSignature}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <SignatureCanvas
                ref={resSignature}
                penColor="black"
                canvasProps={{
                  height: 168,
                  width: width - 48,
                }}
                onEnd={debounce(
                  () =>
                    dispatch({
                      type: "handlSignature",
                      ref: resSignature,
                    }),
                  1000
                )}
              />
            </div>
          )}
        </div>
      </div>
      <DialogNoti {...{ dispatch, data: dialogNoti }} />
      <DialogShowImg {...{ dispatch, state }} />
      <FormReportedAccident {...{ state, dispatch }} />
      <RuleModal
        {...{
          open: !!modalRule?.open,
          onClose: () => dispatch("closeModalRule"),
          url: modalRule?.url || "",
        }}
      />
    </div>
  );
}
